<div class="container" [id]="data?.details?.id">
  <h3 class="section-title text-center mb-4">
    {{ data.details.title.split(" ")[0] }}
    <span>{{ data.details.title.split(" ")[1] }}</span>
  </h3>

  <p-carousel
    dir="ltr"
    [value]="groupedServices"
    [numVisible]="1"
    [numScroll]="1"
    [showIndicators]="false"
    [circular]="true"
    [showNavigators]="true"
  >
    <ng-template let-projects pTemplate="item">
      <div class="row w-100 justify-content-center gx-4 gy-4">
        <div
          class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex"
          *ngFor="let project of projects"
        >
          <div class="service-card text-center d-flex flex-column w-100 h-100">
            <img
              [src]="project.imageIconPath"
              class="card-img-top"
              [alt]="project.titleTr"
              loading="lazy"
            />
            <div
              class="card-body d-flex flex-column"
              [dir]="language === 'ar' ? 'rtl' : 'ltr'"
            >
              <h5 class="card-title">{{ project.titleTr }}</h5>
              <p class="card-text" [innerHTML]="project.description"></p>

              <a
                *ngIf="data.details.isDetails"
                [href]="getDetailsUrl(project)"
                class="details-btn mt-auto"
              >
                {{ "read more" | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-carousel>
</div>
